import { Container } from '@mui/material';
import { ReactNode } from 'react';

import DesktopSliderList from 'components/@lists/DesktopSliderList';
import MobileScrollableList from 'components/@lists/MobileScrollableList';

interface Props {
  minWidthItem: { xs: number; md: number };
  imageRefHeight: number;
  children: ReactNode;
  resetContainer?: boolean;
  gap?: number;
}

/**
 * Renders on desktop a DesktopSliderList and on mobile a MobileScrollableList
 */
const ScrollableList = ({
  minWidthItem,
  imageRefHeight,
  children,
  gap,
}: Props) => {
  return (
    <>
      <Container

      // container is needed. We offset the spacing inside MobileScrollableList: this is not ideal!
      >
        <MobileScrollableList gap={gap} minWidthItem={minWidthItem.xs}>
          {children}
        </MobileScrollableList>
      </Container>
      <DesktopSliderList
        minWidthItem={minWidthItem.md}
        imageRefHeight={imageRefHeight}
      >
        {children}
      </DesktopSliderList>
    </>
  );
};

export default ScrollableList;
